import { BaseModel } from '../../_base/crud';

export class AffiliationType extends BaseModel {
  id: number;
  affiliation_type_id: number;
  affiliation_type_name: string;
  affiliation_type_description: string;

  clear() {
    this.id = 0;
    this.affiliation_type_id = 0;
    this.affiliation_type_name = '';
    this.affiliation_type_description = '';
  }
}
